import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { getRegulation } from "@/services/regulation";

type TermsOfUseProps = {
  onAccept: () => void;
};
export default function TermsOfUse({ onAccept }: TermsOfUseProps) {
  const [termsAccepted, setTermsAccepted] = useState(false);

  const [termos, setTermos] = useState<any>();

  useEffect(() => {
    async function loadData() {
      const resp = await getRegulation();
      setTermos(resp.content);
      console.log(resp);
    }

    loadData();
  }, []); 

  return (
    <div id="termos" className="p-20 border h-[85%] flex flex-col text-secondary">
      <h1 className="text-3xl font-bold">Termos de Uso de Dados Pessoais</h1>
      <div className="rounded border p-5 flex-1 overflow-y-auto  my-8">
        <div dangerouslySetInnerHTML={{ __html: termos }}></div>
      </div>
      <div className="flex items-center justify-between">
        <div className="space-x-2">
          <input
            id="accept"
            name="accept"
            type="checkbox"
            onChange={(e: any) => {
              setTermsAccepted(e.nativeEvent.target.checked);
            }}
          />
          <label htmlFor="accept">
            Li e concordo com os termos apresentados
          </label>
        </div>
        <Button
          disabled={!termsAccepted}
          onClick={onAccept}
          className="text-lg p-6 uppercase"
        >
          ENVIAR TERMO
        </Button>
      </div>
    </div>
  );
}
